import '../News/News.scss';

function News() {

    return (

        <>

            <div className="News_Section">
                <h3 className='text'>WE HAVE SOME NEWS!</h3>
                <div className="News_images">
                    <div className="image1">
                        <img src={require('../../assets/Images/NewsImages/News1.avif')} />
                    </div>
                    <div className="image1">
                        <img src={require('../../assets/Images/NewsImages/News3.avif')} />
                    </div>
                    <div className="image1">
                        <img src={require('../../assets/Images/NewsImages/News4.avif')} />
                    </div>
                    <div className="image1">
                        <img src={require('../../assets/Images/NewsImages/News5.avif')} />
                    </div>
                    <div className="image1">
                        <img src={require('../../assets/Images/NewsImages/News6.avif')} />
                    </div>
                </div>
            </div>

            {/* DELIVERING MORE */}

            <div className='DELIVERINGMORE'>
                <h3 className='text'>DELIVERING MORE</h3>
                <div className='icons my-5'>
                    <div className='icon'>
                        <img src={require('../../assets/Images/NewsImages/warranty.webp')} /><br />
                        <small>6 Months warranty</small>
                    </div>
                    <div className='icon'>
                        <img src={require('../../assets/Images/NewsImages/freeShipping.webp')} /><br />
                        <small>Free Shipping</small>
                    </div>
                    <div className='icon'>
                        <img src={require('../../assets/Images/NewsImages/Exchange.webp')} /><br />
                        <small>Easy exchange</small>
                    </div>
                    <div className='icon'>
                        <img src={require('../../assets/Images/NewsImages/SecureCheckout.webp')} /><br />
                        <small>Secure Checkout</small>
                    </div>
                </div>
            </div>


        </>
    )
}

export default News;